// Don't apply 'HeadingBuilder' for this component's 'Tippy contents' (table data)
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
//import { useContext } from 'react';
//import { ShopperContext } from '../context/shopper';
import { useStyles } from "../hooks/useStyles";
import { useLookups } from "../hooks/useSkuUtils";
import * as Constants from '../constants';
import CircleTable from '../components/CircleTable';
import { useTranslation } from "react-i18next";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

export const InvitationLink = ( {invitation} ) => {
  const { t } = useTranslation();
  const { tableOrderItem } = useStyles();

  const [showCircleTable, setShowCircleTable] = useState(false);
  const handleClick = event => {
    setShowCircleTable(current => !current);
  };

  const { lookup_flavor_label, lookup_status_label } = useLookups();

  if (invitation) {
    console.log('Invitationlink InvitationX', invitation)
  } else {
    return 
  }

  const invitationStartsAsAccepted =
    invitation.status === Constants.INVITATION_STATUS_ACCEPTED;
    // 'invitation.status' is the wire value, so compare it against the
    // constant. Comparing against a translated string made this always
    // false on any non-English page.

  const invitationStartingTippy = 
    invitationStartsAsAccepted
      ? t('invitation.status.acceptedDontClick')
      : t('invitation.status.clickToRespond')

  const icircle = {...invitation.circle};
  return (
        <tr style={tableOrderItem}>
          <td>
            { showCircleTable
              ? <CircleTable
                  circle = {icircle}
                  shopperNames = {invitation.shopper_names}
                  handleClick = {handleClick}
                  showDetails = {false}
                />
              : <button onClick={handleClick}>{invitation.circle.identifier}</button>
            }
          </td>
          <td>
            {icircle.postal_code}
          </td>
          <td>
            { lookup_flavor_label({flavor: invitation.flavor}) }
          </td>
          <Tippy content= {invitationStartingTippy} >
            <td>
              { invitationStartsAsAccepted
                ? lookup_status_label({status: invitation.status})
                : <Link to={`/circles/${icircle.id}/invitations/${invitation.id}`}>
                    {lookup_status_label({status: invitation.status})}
                   {/* {t('invitation.status.edit_label')} */}
                  </Link>
              }
            </td>
          </Tippy>
        </tr>
  )
}

export default InvitationLink